
import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';

export const dbConfig: DBConfig = {
  name: 'DbSonEspaceSante',
  version: 1,
  objectStoresMeta: []
};